import React from "react";
import AdminNavbar from "../../../components/Admin/adminNavbar";
import AddBrands from "./addBrands";
import { connect } from "react-redux";
import AuthAdmin from "../../../components/AuthAdmin/AuthAdmin";
import Spinner from "../../../components/Spinner/Spinner";

const Brands = (props) => {

  let {isAuthenticated,admin,staff,userId} = props;
    if(localStorage.getItem("idToken")){
      if(userId == null && admin == null && staff==null){
        return <Spinner/>
      }
    }

    if(!isAuthenticated || !(admin||staff)){
      return <AuthAdmin/>
    }
  return (
    <React.Fragment>
      <AdminNavbar />
      <AddBrands />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated:state.auth.userId!=null,
    admin:state.auth.admin,
    staff:state.auth.staff,
    userId:state.auth.userId
  };
};

export default connect(mapStateToProps, null)(Brands);
